module.exports = __webpack_public_path__ + "img/product2.a2e26c66.png";